<template>
  <div class="report">
    <div v-for=" items in list">
      <div class="title">{{name}}</div>
      <div class="head"><div>出库日期:{{date}} </div><div>出库编号: {{id}}</div>  </div>
      <table>

        <tr>
          <th>时间</th>
          <th>废物编号</th>
          <th>废物序号</th>
          <th>废物名称</th>
          <th>废物物理状态</th>
          <th>废物取出位置</th>
          <th>废物送达位置</th>
          <th>废物处置⽅式代码</th>
          <th>容器材质及容量</th>
          <th>容器个数</th>
          <th>废物重量(kg)</th>
        </tr>
        <tr v-for="item in items">
          <td >{{item[0]}} {{item[1]}}</td>
          <td>{{item[2]}}</td>
          <td>{{item[3]}}</td>
          <td>{{item[4]}}</td>
          <td>{{item[5]}}</td>
          <td>{{item[6]}}</td>
          <td>{{item[7]}}</td>
          <td>{{item[8]}}</td>
          <td>{{item[9]}}</td>
          <td>{{item[10]}}</td>
          <td>{{item[11]}}</td>
        </tr>

      </table>
    </div>
  </div>
</template>
<script>
  import Config from "../config.js"
  export default {
    name: "Month",
    data(){
      return {
        name:"",
        date:"",
        id:"",
        list:[

        ]
      }
    },
    methods:{
      init(){
        this.request(Config.HTTP+"upload?key=10",(res)=>{
         this.list=res.list;
         this.name=res.name;
         this.date=res.date;
         this.id=res.id;
        } )
      },

    },
    mounted(){


    },
    created(){

      this.init()


    }
  }

</script>
<style scoped>
  .report{
    width: 100%;color: #000;}
  .report .title{height:60px;line-height: 60px;font-weight: bold;font-size: 16px;}
  table{
    border-collapse: collapse;
    width: 100%;
  }
  table td{border: 1px solid #000;font-size: 12px;height: 30px;}
  table th{border: 1px solid #000;font-size: 12px;height:30px;}
  .head>div{width: 50%;display: inline-block;text-align: left}
  .head>div:last-child{text-align: right;}
</style>



// WEBPACK FOOTER //
// src/view/report/out.vue